import { getCurrentDevice } from './utils';

const initSelect = (selector) => {
	$(selector).each(function() {
		const $this = $(this);
		const $select = $this.find('select');
		let placeholder = false;

		if ( getCurrentDevice() != 'desktop' ) {
			placeholder = $this.data('placeholder-mobile')
		}

		$select.select2({
			width: '100%',
			minimumResultsForSearch: -1,
			dropdownParent: $this,
			placeholder: placeholder
		})
	})
}

export default function selectUI() {
	initSelect('.select');
}
